function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "typescript",
  d: "M1000,1000c-333.3,0-666.7,0-1000,0C0,666.7,0,333.3,0,0c333.3,0,666.7,0,1000,0 C1000,333.3,1000,666.7,1000,1000z M597.3,823.1c2.9,5.6,4.3,9,6.3,12.1c42.7,67.3,128.7,99,212.6,77.9 c53.6-13.5,93.6-43,102.4-100.6c9.1-59.2-9.7-108.7-63.6-139.9c-26.2-15.1-54.2-27-81.2-40.7c-13.8-7-28.1-13.4-40.7-22.3 c-14.7-10.5-20.5-27.5-13.1-43.3c5.2-11.2,16.9-23.4,28.3-26.9c22.3-6.8,44-0.6,59.8,18.8c4.6,5.5,9.2,11,14.8,17.6 c24.3-16.2,47.2-31.5,69.9-46.7c-31.7-54.3-77.3-74.8-135.5-73.4c-64.2,1.6-115.2,34.2-127.6,89.8c-13.2,59.6-0.8,110.5,60.7,148.6 c21.9,13.5,46.2,23.1,69.2,34.8c16.4,8.3,33.8,15.5,48.7,26c28.9,20.4,24.5,58.5-7.9,72.9c-9.9,4.4-21.2,6.8-32,7.6 c-43.4,3.1-72.3-20.7-95.9-55.9C647.4,794.1,623.3,808.1,597.3,823.1z M348.5,542.7c0,124.2,0,246,0,368.8c32,0,61.2,0,93.1,0 c0-123.1,0-244.8,0-368.8c44.4,0,86.2,0,127.9,0c0-28.4,0-54.4,0-80.6c-117.6,0-232.7,0-349.6,0c0,27.1,0,52.6,0,80.7 C262.2,542.7,304,542.7,348.5,542.7z"
}));

function SvgTypescript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    className: "typescript",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.d0e9451e.svg";
export { ForwardRef as ReactComponent };